// extracted by mini-css-extract-plugin
export default {"mainContainer":"ArticleDownload_mainContainer__fUGhv","containerImgDownload":"ArticleDownload_containerImgDownload__nhH7r","imgDownload":"ArticleDownload_imgDownload__wWleL"};